module.exports = __webpack_public_path__ + "img/12000.09e02d87.jpg";